export const messages = {
  moreInformation: {
    id: 'admin/promotions.links.restrictions.opt-in.more-information',
  },
  view: {
    description: {
      id: 'admin/promotions.form.sellers.opt-in.description',
    },
    viewAll: {
      id: 'admin/promotions.form.sellers.opt-in.view-all',
    },
    label: {
      id: 'admin/promotions.form.sellers.opt-in.label',
    },
  },
  drawer: {
    title: {
      id: 'admin/promotions.form.sellers.opt-in.title',
    },
    subtitle: {
      id: 'admin/promotions.form.sellers.opt-in.subtitle',
    },
    close: {
      id: 'admin/promotions.utils.close',
    },
    sellerName: {
      id: 'admin/promotions.form.sellers.opt-in.seller',
    },
    sellerId: {
      id: 'admin/promotions.form.sellers.opt-in.seller-id',
    },
    emptyName: {
      id: 'admin/promotions.form.sellers.opt-in.empty-name',
    },
  },
  confirmation: {
    title: { id: 'admin/promotions.utils.modal.confirmation.title' },
    description: { id: 'admin/promotions.utils.modal.opt-in.description' },
    subtitle: { id: 'admin/promotions.utils.modal.confirmation.subtitle' },
    cancel: { id: 'admin/promotions.utils.cancel' },
    continue: { id: 'admin/promotions.utils.continue' },
  },
}
